// extracted by mini-css-extract-plugin
module.exports = {"NewNote":"NewNote-module__NewNote___3GZA0","TextNote":"NewNote-module__TextNote___1zh7J"};